<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form-setting" size="medium">
      <el-form-item :label="$i18n.t('wm_lang_abeee9')" prop="spamLevel">
        <el-select v-model="ruleForm.spamLevel" placeholder="">
          <el-option v-for="(item, index) in ruleFormSpamLevels" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_6105e1')" prop="executeOptType">
        <el-select v-model="ruleForm.executeOptType" placeholder="">
          <el-option v-for="(item, index) in ruleFormExecuteOptTypes" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_31fd4b')" prop="executeOptType">
        <el-select v-model="ruleForm.spamMailDeleteTime" placeholder="">
          <el-option v-for="(item, index) in ruleFormSpamMailDeleteTimes" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label=this.$i18n.t('wm_lang_4848e1') prop="remindEnable">-->
        <!--<el-switch v-model="ruleForm.remindEnable"></el-switch>-->
      <!--</el-form-item>-->
      <el-form-item :label="$i18n.t('wm_lang_4848e1')" prop="remindCycle">
        <!--<span class="f12 c_blue">{{$t("wm_lang_html_5a3009")}}</span>-->
        <el-select v-model="ruleForm.remindCycle" placeholder="">
          <el-option v-for="(item, index) in ruleFormRemindCycles" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
        <el-select class="m-list" v-model="ruleForm.remindStartTime" placeholder="" v-show="ruleForm.remindCycle === 1">
          <el-option v-for="(item, index) in ruleFormRemindTimes" :key="index" :label="item.name" v-show="item.value === '' || item.value !== ruleForm.remindEndTime" :value="item.value"></el-option>
        </el-select>
        <span v-show="ruleForm.remindCycle === 1">{{$t("wm_lang_html_ab20cc")}}</span>
        <el-select class="m-list" v-model="ruleForm.remindEndTime" placeholder="" v-show="ruleForm.remindCycle === 1">
          <el-option v-for="(item, index) in ruleFormRemindTimes" :key="index" :label="item.name" v-show="item.value === '' || item.value !== ruleForm.remindStartTime" :value="item.value"></el-option>
        </el-select>
        <!--<span class="f12 c_blue">{{$t("wm_lang_html_570e7f")}}</span>-->
      </el-form-item>
      <!--<el-form-item label="" prop="remindLanguage">-->
        <!--<span class="f12 c_blue">{{$t("wm_lang_html_74c0d8")}}</span>-->
        <!--<el-select v-model="ruleForm.remindLanguage" placeholder="" :disabled="!ruleForm.remindEnable">-->
          <!--<el-option v-for="(item, index) in ruleFormRemindLanguages" :key="index" :label="item.name" :value="item.value"></el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <!--<el-form-item label=this.$i18n.t('wm_lang_a9e825') prop="mailPictureVisiable">-->
        <!--<el-select v-model="ruleForm.mailPictureVisiable" placeholder="">-->
          <!--<el-option v-for="(item, index) in ruleFormMailPictureVisiables" :key="index" :label="item.name" :value="item.value"></el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
    <br><br>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import { isEmail } from '@/utils/validate';

export default {
  name: 'antiSpamSetting',
  data () {
    return {
      ruleForm: {
        spamLevel: 2,
        executeOptType: 1,
        spamMailDeleteTime: 1,
        // remindEnable: false,
        mailPictureVisiable: 2,
        remindCycle: 0,
        // remindLanguage: 1,
        remindStartTime: '',
        remindEndTime: ''
      },
      ruleFormSpamLevels: [
        {name: this.$i18n.t('wm_lang_ca5f4c'), value: xmail.enums.SpamLevel.LOW},
        {name: this.$i18n.t('wm_lang_0d64f2'), value: xmail.enums.SpamLevel.MEDIUM},
        {name: this.$i18n.t('wm_lang_5cd3b6'), value: xmail.enums.SpamLevel.HIGH}
      ],
      ruleFormExecuteOptTypes: [
        {name: this.$i18n.t('wm_lang_bce314'), value: xmail.enums.SpamExecuteOptType.SPAM_FOLDER},
        {name: this.$i18n.t('wm_lang_2ef722'), value: xmail.enums.SpamExecuteOptType.UN_ACCEPT}
      ],
      ruleFormSpamMailDeleteTimes: [
        {name: '30'+this.$i18n.t('wm_lang_249aba'), value: 30},
        {name: '15'+this.$i18n.t('wm_lang_249aba'), value: 15},
        {name: '7'+this.$i18n.t('wm_lang_249aba'), value: 7}
      ],
      ruleFormMailPictureVisiables: [
        {name: this.$i18n.t('wm_lang_3683f3'), value: xmail.enums.MailPictureVisiable.ENABLE},
        {name: this.$i18n.t('wm_lang_6fc450'), value: xmail.enums.MailPictureVisiable.DISABLE_SPAM},
        {name: this.$i18n.t('wm_lang_b1baab'), value: xmail.enums.MailPictureVisiable.DISABLE}
      ],
      ruleFormRemindCycles: [
        {name: this.$i18n.t('wm_lang_55481b'), value: 0},
        {name: this.$i18n.t('wm_lang_78623e'), value: 1},
        {name: this.$i18n.t('wm_lang_e2ee4e'), value: 2},
        {name: this.$i18n.t('wm_lang_03dcfd'), value: 3},
        {name: this.$i18n.t('wm_lang_f2e77e'), value: 4},
        {name: this.$i18n.t('wm_lang_19fee2'), value: 5},
        {name: this.$i18n.t('wm_lang_0d5523'), value: 6}
      ],
      // ruleFormRemindLanguages: [
      //   {name: this.$i18n.t('wm_lang_0b2f8e'), value: 1},
      //   {name: this.$i18n.t('wm_lang_aef8cb'), value: 2},
      //   {name: this.$i18n.t('wm_lang_f9fb6a'), value: 3},
      //   {name: this.$i18n.t('wm_lang_cef67a'), value: 4},
      //   {name: this.$i18n.t('wm_lang_bc2f65'), value: 5}
      // ],
      ruleFormRemindTimes: [
        {name: '--:--', value: ''},
        {name: '02:00', value: 7200},
        {name: '04:00', value: 14400},
        {name: '06:00', value: 21600},
        {name: '08:00', value: 28800},
        {name: '12:00', value: 43200},
        {name: '15:00', value: 54000},
        {name: '18:00', value: 64800},
        {name: '20:00', value: 72000}
      ],
      rules: {
        //
      }
    }
  },
  mounted() {
    let self = this;
    (function (api, enums, pms) {
      api.Antispam.queryMailAntispamInfo({}, function (res) {
        if(res.data.code === 0) {
          console.log(res.data.data);
          self.ruleForm.spamLevel = res.data.data.spamLevel;
          self.ruleForm.executeOptType = res.data.data.executeOptType;
          self.ruleForm.spamMailDeleteTime = res.data.data.spamMailDeleteTime;
          // self.ruleForm.remindEnable = res.data.data.remindEnable;
          self.ruleForm.remindCycle = res.data.data.remindCycle;
          if(self.ruleForm.remindCycle === 1) {
            self.ruleForm.remindStartTime = res.data.data.remindStartTime ? res.data.data.remindStartTime : '';
            self.ruleForm.remindEndTime = res.data.data.remindEndTime ? res.data.data.remindEndTime : '';
          }
          // self.ruleForm.remindLanguage = res.data.data.remindLanguage;
          self.ruleForm.mailPictureVisiable = res.data.data.mailPictureVisiable;
        }
      })
    })(xmail.api, xmail.enums, xmail.pms);
  },
  methods: {
    submitForm(formName) {
      let self = this;
      (function (api, enums, pms) {
        let pm = self.ruleForm;
        api.Antispam.saveMailAntispamInfo(pm, function (res) {
          // console.log(res)
          if(res.data.code === 0) {
            self.$message({
              dangerouslyUseHTMLString: true,
              message: '<strong>'+self.$i18n.t('wm_lang_314f60')+' <a href="/">'+self.$i18n.t('wm_lang_694fc5')+'</a>'+self.$i18n.t('wm_lang_5f6025')+'</strong>'
            });
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/antiSpamSetting.vue